import { teacherServiceURL } from '../endpoint';

export const questionScoresURL = ({
  activityInstanceId,
  questionId,
}: {
  activityInstanceId: number;
  questionId: number;
}) => {
  return new URL(
    `activities/${activityInstanceId}/questions/${questionId}/scores`,
    teacherServiceURL
  );
};
